module.exports = __webpack_public_path__ + "static/media/2e2b52f4b4818ff34e00cffdb4814194.d570589d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/thumbs/2e2b52f4b4818ff34e00cffdb4814194.jpg
// module id = 295
// module chunks = 0